import { ACQUISITION_KEY } from '@/utils/acquisition';

/**
 * Storage Service - Handles all localStorage and sessionStorage operations
 */
const storageService = {
  /**
   * Clear all storage items
   */
  clearAllStorage: ({ preserveAcquisition = false } = {}) => {
    const acquisition = preserveAcquisition ? localStorage.getItem(ACQUISITION_KEY) : null;
    // Clear localStorage
    localStorage.clear();

    // Clear sessionStorage
    sessionStorage.clear();
    if (acquisition) localStorage.setItem(ACQUISITION_KEY, acquisition);
  },

  /**
   * Clear specific storage items by prefix
   * @param {string} prefix - Prefix of items to clear
   */
  clearStorageByPrefix: (prefix) => {
    // Clear localStorage items with prefix
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(prefix)) {
        localStorage.removeItem(key);
      }
    });

    // Clear sessionStorage items with prefix
    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith(prefix)) {
        sessionStorage.removeItem(key);
      }
    });
  },

  /**
   * Set item in storage
   * @param {string} key - Storage key
   * @param {any} value - Value to store
   * @param {boolean} useSession - Whether to use sessionStorage instead of localStorage
   */
  setItem: (key, value, useSession = false) => {
    const storage = useSession ? sessionStorage : localStorage;
    storage.setItem(key, JSON.stringify(value));
  },

  /**
   * Get item from storage
   * @param {string} key - Storage key
   * @param {boolean} useSession - Whether to use sessionStorage instead of localStorage
   * @returns {any} Stored value or null if not found
   */
  getItem: (key, useSession = false) => {
    const storage = useSession ? sessionStorage : localStorage;
    const item = storage.getItem(key);
    return item ? JSON.parse(item) : null;
  },

  /**
   * Remove item from storage
   * @param {string} key - Storage key
   * @param {boolean} useSession - Whether to use sessionStorage instead of localStorage
   */
  removeItem: (key, useSession = false) => {
    const storage = useSession ? sessionStorage : localStorage;
    storage.removeItem(key);
  },
};

export default storageService;
